export enum BasePath {
  Dashboard = 'dashboard',
  Transactions = 'transactions',
  Reports = 'reports/:reportType?',
  ReportDetails = 'reports/:reportType/:reportId',
  Settings = 'settings',
  Sources = 'sources',
  Accounting = 'accounting',
  AccountingMapping = 'accounting/mappings',
  Contacts = 'contacts',
  ContactsSaved = 'contacts/saved',
  ContactsUnknownAddresses = 'contacts/unknown-addresses',
  Rules = 'rules',
  PrincipalMarketAnalysis = 'pma',
  Cases = 'cases',
  Vouchers = 'vouchers',
  VoucherDetails = 'vouchers/:voucherId',
  VoucherDetailsOverview = 'vouchers/:voucherId/overview',
  VoucherDetailsTransactions = 'vouchers/:voucherId/transactions',
}

export enum SettingsPath {
  Accounting = 'accounting',
  Tax = 'tax',
  LegalEntity = 'entities',
  OrgControls = 'org-controls',
  Categories = 'categories',
  CustomFields = 'custom-fields',
  SpamTokens = 'spam-tokens',
  StableCoins = 'stable-coins',
  Team = 'team',
  IngestionJobs = 'ingestion-jobs',
  Overview = 'overview',
  Pricing = 'pricing',
  Requests = 'requests',
  Workers = 'workers',
  OrgMetadata = 'organization',
  ImposterAllowList = 'imposter-allowlist',
  AuditLog = 'audit-log',
}
